

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Snackbar from 'material-ui/Snackbar'
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Intro from '../home/sections/intro/Intro'
import GoogleLogin from '../../components/google-login';

import './Quotation.css'

class Quotation extends Component {

  constructor(props) {
    super(props)
  }

  componentDidMount = () => {

  }

  login = (licenseType) => {
    document.licenseType = licenseType;
    this.googleLogin.signIn();
  }

  contact = (e) => {

  };

  onLoginSuccessed = () => {
    this.props.history.push(`/registration`);
    console.log(`Exitoso!`);
  }

  onLoginFailed = () => {
    console.log(`Fallido!`);
  };



  render() {
    return (
      <div className="quotation-page">
        <div className="quotation">
          <GoogleLogin
            ref={(googleLogin) => { this.googleLogin = googleLogin; }}
            onSuccess={this.onLoginSuccessed}
            onFailure={this.onLoginFailed}
          />
          <Intro />
          <br />
          <br />
          <br />
          <div className="row">
            <div className="col-md-3">
              <Card expanded={true}>
                <CardTitle title="Pequeña empresa" subtitle="Hasta 100 personas" expandable={false} />
                <CardText expandable={false}>
                  <ul>
                    <li>Playlists actualizados</li>
                    <li>Logo personalizado</li>
                    <li>Código de votación personalizado</li>
                    <li>Restricciones personalizadas</li>
                    <li>Streaming Youtube</li>
                    <li>Normalización de volumén</li>
                    <li>Certificado de licencia de comunicación pública</li>
                    <li>1 ubicación</li>
                  </ul>
                  <h1 className="price">Q 199.00 al mes</h1>
                </CardText>
                <CardActions>
                  <FlatButton className="btn-adquire" label="Adquirir" onClick={() => this.login(1)} />
                </CardActions>
              </Card>
            </div>
            <div className="col-md-3">
              <Card expanded={true}>
                <CardTitle title="Mediana empresa" subtitle="Hasta 500 personas" expandable={false} />
                <CardText expandable={false}>
                  <ul>
                    <li>Playlists actualizados</li>
                    <li>Logo personalizado</li>
                    <li>Código de votación personalizado</li>
                    <li>Restricciones personalizadas</li>
                    <li>Streaming Youtube</li>
                    <li>Normalización de volumén</li>
                    <li>Certificado de licencia de comunicación pública</li>
                    <li>1 ubicación</li>
                  </ul>
                  <h1 className="price">Q 399.00 al mes</h1>
                </CardText>
                <CardActions>
                  <FlatButton className="btn-adquire" label="Adquirir" onClick={() => this.login(2)} />
                </CardActions>
              </Card>
            </div>
            <div className="col-md-3">
              <Card expanded={true}>
                <CardTitle title="Empresarial" subtitle="Hasta 10 mil personas" expandable={false} />
                <CardText expandable={false}>
                  <ul>
                    <li>Playlists actualizados</li>
                    <li>Logo personalizado</li>
                    <li>Código de votación personalizado</li>
                    <li>Restricciones personalizadas</li>
                    <li>Streaming Youtube</li>
                    <li>Normalización de volumén</li>
                    <li>Certificado de licencia de comunicación pública</li>
                    <li>1 ubicación</li>
                  </ul>
                  <h1 className="price">Q 1,999.00 al mes</h1>
                </CardText>
                <CardActions>
                  <FlatButton className="btn-adquire" label="Adquirir" onClick={() => this.login(3)} />
                </CardActions>
              </Card>
            </div>
            <div className="col-md-3">
              <Card expanded={true}>
                <CardTitle title="Corporativo" subtitle="Más de 10 mil personas" expandable={false} />
                <CardText expandable={false}>
                  <ul>
                    <li>Playlists actualizados</li>
                    <li>Logo personalizado</li>
                    <li>Código de votación personalizado</li>
                    <li>Restricciones personalizadas</li>
                    <li>Streaming Youtube</li>
                    <li>Normalización de volumén</li>
                    <li>Certificado de licencia de comunicación pública</li>
                    <li>Muchas ubicaciones</li>
                  </ul>
                  <h1 className="price">&nbsp;&nbsp;&nbsp;</h1>
                </CardText>
                <CardActions>
                  <FlatButton className="btn-adquire" label="Contactar" onClick={this.contact} />
                </CardActions>
              </Card>
            </div>
          </div>
        </div>
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <section className="bottom">
            <div className="bottom-content">
              <span>Powered by <a className="powered-by" href="http://www.adstter.com">Adstter</a></span>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default withRouter(Quotation)



// WEBPACK FOOTER //
// ./src/pages/quotation/Quotation.js